export default __webpack_public_path__ + "static/media/loading.5d3e46a2.gif";